var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTentCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2483 20.5776L24.8966 27.8397V35.1018",
    stroke: "#230F4E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6676 35.1002V30.2588L19.2469 27.0312L16.8262 30.2588V35.1002",
    fill: "#EEEFF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6676 35.1002V30.2588L19.2469 27.0312L16.8262 30.2588V35.1002",
    stroke: "#230F4E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5996 35.1018V27.8397L19.2479 20.5776H30.5444L36.1927 27.8397V35.1018H13.5996Z",
    stroke: "#230F4E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7723 17.3497C35.5548 17.3497 36.9999 15.9047 36.9999 14.1221C36.9999 12.3396 35.5548 10.8945 33.7723 10.8945C31.9897 10.8945 30.5447 12.3396 30.5447 14.1221C30.5447 15.9047 31.9897 17.3497 33.7723 17.3497Z",
    fill: "#EEEFF0",
    stroke: "#230F4E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTentCircle);
export default __webpack_public_path__ + "static/media/tent-circle.a7c20e6b9ba715d58656d1a66dddd7f0.svg";
export { ForwardRef as ReactComponent };